"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _interfaces = require("./interfaces");

Object.keys(_interfaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interfaces[key];
    }
  });
});
var primaryFont = {
  family: '"Amazon Ember", Helvetica, sans-serif',
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700
  },
  size: {
    T800: {
      xl: {
        fontSize: '4rem',
        lineHeight: 1.25
      },
      l: {
        fontSize: '3.5rem',
        lineHeight: 1.25
      },
      m: {
        fontSize: '3rem',
        lineHeight: 1.25
      },
      s: {
        fontSize: '2.5rem',
        lineHeight: 1.3
      }
    },
    T700: {
      xl: {
        fontSize: '3rem',
        lineHeight: 1.25
      },
      l: {
        fontSize: '2.75rem',
        lineHeight: 1.31818
      },
      m: {
        fontSize: '2.75rem',
        lineHeight: 1.18182
      },
      s: {
        fontSize: '2.125rem',
        lineHeight: 1.29412
      }
    },
    T600: {
      xl: {
        fontSize: '2.5rem',
        lineHeight: 1.3
      },
      l: {
        fontSize: '2.25rem',
        lineHeight: 1.3333
      },
      m: {
        fontSize: '2rem',
        lineHeight: 1.375
      },
      s: {
        fontSize: '1.75rem',
        lineHeight: 1.35714
      }
    },
    T500: {
      xl: {
        fontSize: '2rem',
        lineHeight: 1.375
      },
      l: {
        fontSize: '1.75rem',
        lineHeight: 1.42857
      },
      m: {
        fontSize: '1.625rem',
        lineHeight: 1.46154
      },
      s: {
        fontSize: '1.375rem',
        lineHeight: 1.45455
      }
    },
    T400: {
      xl: {
        fontSize: '1.5rem',
        lineHeight: 1.5
      },
      l: {
        fontSize: '1.375rem',
        lineHeight: 1.54545
      },
      m: {
        fontSize: '1.25rem',
        lineHeight: 1.4
      },
      s: {
        fontSize: '1.125rem',
        lineHeight: 1.55556
      }
    },
    T300: {
      xl: {
        fontSize: '1.125rem',
        lineHeight: 1.55556
      },
      l: {
        fontSize: '1.125rem',
        lineHeight: 1.55556
      },
      m: {
        fontSize: '1rem',
        lineHeight: 1.5
      },
      s: {
        fontSize: '1rem',
        lineHeight: 1.5
      }
    },
    T200: {
      xl: {
        fontSize: '1rem',
        lineHeight: 1.5
      },
      l: {
        fontSize: '1rem',
        lineHeight: 1.5
      },
      m: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      },
      s: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      }
    },
    T100: {
      xl: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      },
      l: {
        fontSize: '0.875rem',
        lineHeight: 1.57143
      },
      m: {
        fontSize: '0.75rem',
        lineHeight: 1.66667
      },
      s: {
        fontSize: '0.75rem',
        lineHeight: 1.66667
      }
    }
  }
};
var defaultTheme = {
  color: {
    primary: '#007486',
    primaryLight: '#008296',
    primaryDark: '#006170',
    primaryTint: '#eef5f6',
    secondary1: '#c34789',
    secondary2: '#4862c8',
    accent1: '#232f3e',
    accent2: '#5c7274',
    accent3: '#799294',
    accent4: '#bdd3d5',
    accent5: '#d4e4e6',
    accent6: '#eef5f6',
    positive: '#0b8753',
    positiveLight: '#3b9f75',
    positiveDark: '#086c42',
    positiveTint: '#e6f3ed',
    negative: '#cd3e3e',
    negativeLight: '#d35555',
    negativeDark: '#a43131',
    negativeTint: '#fbefef',
    warning: '#cc7a00',
    warningLight: '#d69433',
    warningDark: '#9e6209',
    warningTint: '#fdf4e6',
    white: '#ffffff',
    black: '#000000'
  },
  space: {
    S100: 4,
    S200: 8,
    S300: 16,
    S400: 24,
    S500: 32,
    S600: 48,
    S700: 64
  },
  breakpoint: {
    s: {
      max: 600
    },
    m: {
      min: 601,
      max: 970
    },
    l: {
      min: 971,
      max: 1280
    },
    xl: {
      min: 1281
    }
  },
  // we should only load webfonts if they are not local
  // https://developers.google.com/web/fundamentals/performance/optimizing-content-efficiency/webfont-optimization?hl=en#defining-font-family-with-font-face
  font: {
    primary: primaryFont,
    monospace: (0, _objectSpread2.default)({}, primaryFont, {
      family: '"Amazon Ember Mono", Consolas, Monaco, monospace'
    })
  },
  zIndex: {
    modal: 900,
    flyout: 800,
    header: 700,
    stickyContent: 650,
    sideMenu: 600,
    dropdown: 500,
    popover: 400,
    alert: 300
  },
  constants: {
    maxWidth: 1440,
    pageHorizontalPadding: '2.5vw',
    headerHeight: 56
  }
};
var _default = defaultTheme;
exports.default = _default;